// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__i6lXH","image":"AboutUs_image__2UzHk","textContainer":"AboutUs_textContainer__fScjB"};